import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import '../CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import classNames from 'classnames';
import CustomAlert from '../../CustomAlert';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { checkIsMemberExistsOrNot, createTeamDocument } from '../../../Backend/firebase/team';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreateTeam() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        var checkIsUserExists = await checkIsMemberExistsOrNot(data.email)
        console.log('checkIsUserExists', checkIsUserExists)
        if (checkIsUserExists.length <= 0) {
            var newTeam = {};
            newTeam.userId = userData.uid;
            newTeam.MemberName = data.MemberName;
            newTeam.MemberEmail = data.MemberEmail;
            newTeam.Role = data.Role;
            newTeam.Department = data.Department;
            try {
                var member = createTeamDocument(newTeam);
                if (member) {
                    setNotificationMessage('Member Added successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    reset();
                    setIsLoading(false);
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/add-member');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/add-member');
            }
        } else {
            setIsLoading(false);
            setNotificationMessage(
              'Member with this email address is already exists, please try again with another email!!',
            )
            setOpenNotify(true);
            setAlertType('error');
          }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/my-team';
    }


    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating New Member page." />
                    <title>Create New Member | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <h5>Basic Details</h5>
                            <div className="col-md-6 mb-2">
                                Member Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MemberName })}
                                    name="MemberName" autoComplete="none"
                                    ref={register({ required: 'Please enter Member Name!' })} />
                                <small className="form-text text-danger">{errors.MemberName && errors.MemberName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Member Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="email" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MemberEmail })}
                                    name="MemberEmail" autoComplete="none"
                                    ref={register({ required: 'Please enter Member Email!' })} />
                                <small className="form-text text-danger">{errors.MemberEmail && errors.MemberEmail.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Department
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="Department" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Role <span className="text-danger" style={{ fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.Role })} 
                                    aria-label="Default select example"
                                    name="Role" ref={register({
                                        required: 'Please select Role!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Role!'
                                        }
                                    })} defaultValue="Select Role" >
                                    <option value={'Sales Team'}>{'Sales Team'}</option>
                                    <option value={'Purchase Team'}>{'Purchase Team'}</option>
                                    <option value={'Stockist'}>{'Stockist'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.Role && errors.Role.message}</small>
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Add New Member'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default CreateTeam

